import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
// Extend Zod with OpenAPI
extendZodWithOpenApi(z);
// UUID validation
const uuidSchema = z.string().uuid('Invalid UUID format');
// Create topic input schema
export const CreateTopicSchema = z.object({
    title: z
        .string()
        .min(1, 'Title is required')
        .max(255, 'Title must be less than 255 characters')
        .trim()
        .openapi({
        description: 'Topic title',
        example: 'Data Types and Variables',
    }),
    description: z
        .string()
        .max(5000, 'Description must be less than 5000 characters')
        .nullable()
        .optional()
        .openapi({
        description: 'Detailed topic description',
        example: 'Covers primitive and complex data types',
    }),
});
// Update topic input schema (all fields optional)
export const UpdateTopicSchema = z.object({
    title: z
        .string()
        .min(1, 'Title cannot be empty')
        .max(255, 'Title must be less than 255 characters')
        .trim()
        .optional()
        .openapi({
        description: 'Updated topic title',
        example: 'Advanced Data Types',
    }),
    description: z
        .string()
        .max(5000, 'Description must be less than 5000 characters')
        .nullable()
        .optional()
        .openapi({
        description: 'Updated topic description',
    }),
    lessonIds: z
        .array(uuidSchema)
        .optional()
        .openapi({
        description: 'List of lesson IDs associated with the topic',
        example: ['550e8400-e29b-41d4-a716-446655440000'],
    }),
});
// List topics query parameters
export const ListTopicsQuerySchema = z.object({
    page: z
        .string()
        .optional()
        .default('1')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0, 'Page must be greater than 0'),
    pageSize: z
        .string()
        .optional()
        .default('10')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0 && val <= 100, 'Page size must be between 1 and 100'),
    sortBy: z.enum(['createdAt', 'updatedAt', 'title']).optional().default('createdAt').openapi({
        description: 'Field to sort results by',
        example: 'createdAt',
    }),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc').openapi({
        description: 'Sort direction',
        example: 'desc',
    }),
    moduleId: uuidSchema.optional().openapi({
        description: 'Filter topics by module ID',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
// Topic ID parameter validation
export const TopicIdParamSchema = z.object({
    topicId: uuidSchema.openapi({
        description: 'Unique identifier of the topic',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
// Get topic query parameters (for include)
export const GetTopicQuerySchema = z.object({
    include: z.enum(['lessons', 'content']).optional().openapi({
        description: 'Include related data: lessons (1 level) or content (full nested structure with steps)',
        example: 'lessons',
    }),
});
// Topic Schema
export const TopicSchema = z
    .object({
    id: uuidSchema.openapi({
        description: 'Unique topic identifier',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
    title: z.string().openapi({ description: 'Topic title', example: 'Data Types and Variables' }),
    description: z.string().nullable().openapi({ description: 'Topic description' }),
    createdAt: z.string().openapi({ description: 'Timestamp when the topic was created' }),
    updatedAt: z.string().openapi({ description: 'Timestamp when the topic was last updated' }),
})
    .openapi('Topic');
//# sourceMappingURL=topic.schema.js.map